import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import IconMail from '../../../../assests/header-dashboard/icon-mail.png'
import IconPhone from '../../../../assests/header-dashboard/icon-phone.png'
import classes from './Support.module.css'
import { generalApi } from '../../../../utils'
import ToastMessage from "../../../UI/ToastMessage";
import { throwApiError } from "../../../lms-shared/store/error-handling-actions";

const Support = () => {
    const [message, setMessage] = useState(null)
    const texts = useSelector(state => state.translate.texts);
    const uiData = useSelector((state) => state.general.uiData);
    const { register, handleSubmit, watch, formState: { errors }, reset } = useForm();
    const dispatch = useDispatch()

    function sendSupport() {
        const data = {
            userName: watch("fullName"),
            userPhone: watch("tel"),
            userAddress: watch("mail"),
            subject: watch("subject"),
            body: watch("InputContent")
        }
        generalApi.generalSupportRequestPost({ supportRequestInput: data }, (error, resdata, response) => {

            if (error) {
                dispatch(throwApiError({ userMessage: "", error: error, statusCode: response?.statusCode, message: "generalSupportRequestPost " + error.message, level: 1, component: "Support", line: 29 }))
                setMessage(<ToastMessage color={"red"} text={"ארעה תקלה נסה שוב מאוחר יותר"} close={setMessage}></ToastMessage>)
            }
            else {
                setMessage(<ToastMessage color={"green"} text={"הפנייה נשלחה בהצלחה"} close={setMessage}></ToastMessage>)
                reset();
            }
        })
    }

    return (
        <div className={classes.SupportContainer}>
            {message}
            <div className={classes.SkillzSupport}>{texts.skillsSupportCenter}</div>
            <form className={classes.FormContainer} onSubmit={handleSubmit(sendSupport)}>
                <input className={classes.Input} placeholder={texts.fullName}  {...register('fullName', { required: true })} />
                <input className={classes.Input} placeholder={texts.tel} {...register('tel', {
                    required: true,
                    pattern: {
                        value: /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{3,6}$/im,
                        message: true
                    }
                })} />
                {errors.tel?.message && <p className={classes.ErrorInput}>{texts.ErrorInvalidPhone}</p>}
                <input className={classes.Input} placeholder={texts.mail} {...register('mail', {
                    required: true,
                    pattern: {
                        value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                        message: true,
                    }
                })} />
                {errors.mail?.message && <p className={classes.ErrorInput}>{texts.ErrorInvalidEmail}</p>}
                <input className={classes.Input} placeholder={texts.subject} {...register('subject', { required: true })} />
                <textarea className={`${classes.Input}  ${classes.InputContent}`} placeholder={texts.supportContent} {...register('InputContent', { required: true })} />
                {(errors.fullName || (errors.tel && watch("tel") === '') || (errors.mail && watch("mail") === '') || errors.subject || errors.InputContent) && <p className={classes.ErrorInput}>{texts.ErrorRequiredFields}</p>}
                <input type="submit" className={classes.BtnSend} value={texts.send} />
            </form>
            <p className={classes.MailAndPhoneContainer}>{texts.questionsTechnicalIssuesOrMalfunctions}</p>
            <p className={classes.Mail}><img src={IconMail} alt="mail" /> Support@skillz-edu.org</p>
            <div className={classes.Phone}><img src={IconPhone} alt="phone" /> <div>*6552 → 1 → 3</div></div>
            {/* <p className={classes.goodToKnowContent}>{texts.supportFillForm}</p>
            <button className={classes.BtnSend}>
                <a className={classes.ToFormLink} href={uiData.supportFillFormUrl} target="_blank">{texts.toForm}</a>
            </button> */}
            <p className={classes.goodToKnowTitle}>{texts.goodToKnow}</p>
            <p className={classes.goodToKnowContent}>{texts.supportGoodToKnowContent}</p>
            {uiData && <p className={classes.goodToKnowContent}><a href={uiData.MOENewPassword} className={classes.Link}>{texts.clickHere}</a> {texts.supportEnterWithSMS}</p>}
            {uiData && <p className={classes.goodToKnowContent}>{texts.supportNewPassword} <a href={uiData.MOENewPassword} className={classes.Link}>{texts.clickHere}</a></p>}
            <p className={classes.goodToKnowContent}>{texts.supportPasswordCenter}</p>
            <p className={`${classes.goodToKnowContent} ${classes.Phone}`}><img src={IconPhone} alt="phone" /> *6552</p>
            <p className={classes.goodToKnowContent}>{texts.supportTelephoneAnswer}</p>
        </div >
    )

}

export default Support;